var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}${_vm.slug}`,"viewBox":"0 0 16 16"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","fill":_vm.getColor('sign'),"stroke":"none"}}),_c('polygon',{attrs:{"fill":_vm.getColor('icon'),"stroke":"none","points":"7.5,11.5 4,8 5.4,6.6 7.5,8.6 10.6,5.5 12,6.9 "}})])
}
var staticRenderFns = []

export { render, staticRenderFns }